import { ChangeEvent } from "react";
import { faUndo } from "@fortawesome/free-solid-svg-icons/faUndo";
import { resources } from "@constants/hardcoded-strings";
import { LabelWidthTypes } from "@enums/label-width-types";
import { LayoutTypes } from "@enums/layout-types";
import { AXNUILayoutHelpTextInner } from "@iddataweb/idw-common-ui/types";
import { ThemingGenericContentSlotValidationErrors } from "@idw-types/common/validation/common/theming-validation-errors";
import { TextareaFormGroup } from "../../../../../../common/textarea-form-group/textarea-form-group";
import { InputFormGroup } from "../../../../../../common/input-form-group/input-form-group";

type ContentSlotModalContainerProps = {
    layout: LayoutTypes;
    labelWidth: LabelWidthTypes;
    isDisabled: boolean;
    validationErrors: ThemingGenericContentSlotValidationErrors;
    linkText: string;
    modalHtmlText: string;
    modalCssContent: string;
    defaultLinkText: string;
    defaultModalHtmlText: string;
    defaultModalCssContent: string;
    updateFormContentSlotContentField: (contentField: Partial<AXNUILayoutHelpTextInner>) => void;
};

export const ContentSlotModalContainer = (props: ContentSlotModalContainerProps) => {
    const {
        layout,
        labelWidth,
        isDisabled,
        validationErrors,
        linkText,
        modalHtmlText,
        modalCssContent,
        defaultLinkText,
        defaultModalHtmlText,
        defaultModalCssContent,
        updateFormContentSlotContentField
    } = props;

    const handleModalLinkTextChange = (event: ChangeEvent<HTMLInputElement>) => {
        updateFormContentSlotContentField({ linkText: event.target.value });
    };

    const handleResetModalLinkText = () => {
        updateFormContentSlotContentField({ linkText: defaultLinkText });
    };

    const handleModalTextChange = (event: ChangeEvent<HTMLInputElement>) => {
        updateFormContentSlotContentField({ modalHtmlText: event.target.value });
    };

    const handleResetModalText = () => {
        updateFormContentSlotContentField({ modalHtmlText: defaultModalHtmlText });
    };

    const handleModalCssChange = (event: ChangeEvent<HTMLInputElement>) => {
        updateFormContentSlotContentField({ modalCssContent: event.target.value });
    };

    const handleResetModalCss = () => {
        updateFormContentSlotContentField({ modalCssContent: defaultModalCssContent });
    };


    return (
        <div>
            <InputFormGroup
                controlId={"content-slot-modal-link-text-input"}
                automationId={"content-slot-modal-link-text-input"}
                label={resources.pages.verificationServiceDetails.tabs.theming.subTabs.common.inputs.modalLinkText.label}
                ariaLabel={resources.pages.verificationServiceDetails.tabs.theming.subTabs.common.inputs.modalLinkText.label}
                layout={layout}
                labelWidth={labelWidth}
                onChange={handleModalLinkTextChange}
                value={linkText || ""}
                disabled={isDisabled}
                isRequired={true}
                afterLabelTooltipText={resources.pages.verificationServiceDetails.tabs.theming.subTabs.common.inputs.modalLinkText.tooltip}
                afterLabelIcon={isDisabled ? null : faUndo}
                afterLabelIconOnClick={handleResetModalLinkText}
            />
            {validationErrors.modalLinkTextError}
            <TextareaFormGroup
                controlId={"content-slot-modal-text-input"}
                automationId={"content-slot-modal-text-input"}
                label={resources.pages.verificationServiceDetails.tabs.theming.subTabs.common.inputs.modalText.label}
                ariaLabel={resources.pages.verificationServiceDetails.tabs.theming.subTabs.common.inputs.modalText.label}
                layout={layout}
                labelWidth={labelWidth}
                onChange={handleModalTextChange}
                value={modalHtmlText || ""}
                disabled={isDisabled}
                isRequired={true}
                afterLabelTooltipText={resources.pages.verificationServiceDetails.tabs.theming.subTabs.common.inputs.modalText.tooltip}
                afterLabelIcon={isDisabled ? null : faUndo}
                afterLabelIconOnClick={handleResetModalText}
            />
            {validationErrors.modalHtmlTextError}
            <TextareaFormGroup
                controlId={"content-slot-modal-css-input"}
                automationId={"content-slot-modal-css-input"}
                label={resources.pages.verificationServiceDetails.tabs.theming.subTabs.common.inputs.modalCss.label}
                ariaLabel={resources.pages.verificationServiceDetails.tabs.theming.subTabs.common.inputs.modalCss.label}
                layout={layout}
                labelWidth={labelWidth}
                onChange={handleModalCssChange}
                value={modalCssContent || ""}
                disabled={isDisabled}
                isRequired={false}
                afterLabelTooltipText={resources.pages.verificationServiceDetails.tabs.theming.subTabs.common.inputs.modalCss.tooltip}
                afterLabelIcon={isDisabled ? null : faUndo}
                afterLabelIconOnClick={handleResetModalCss}
            />
        </div>
    );
};